<template>
	<div>
		<div v-html="formstr"></div>
	</div>
</template>

<script>
	export default {
	name: 'Alipay',
	data() {
		return {
			formstr:'',
		}
	},
	created() {
		var str=this.$route.query.formstr||""
		this.formstr=str;
		if (str!==""){
			this.$nextTick(()=>{
				document.forms[0].submit();
			})
		}
	}
	}
</script>

<style>
</style>
